import React, { useState } from 'react';
import { Button, Form, Input } from 'antd';
import { toast } from '../../../lib/toast';
import { signupTenant } from '../../tenants/api/tenants';

interface FormValues {
  companyName: string;
  primaryContactEmail: string;
  primaryContactFirstName: string;
  primaryContactLastName: string;
  phone?: string;
}

const SignupRequestSection: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  async function onFinish(values: FormValues) {
    setLoading(true);
    const result = await signupTenant(values);
    setLoading(false);
    if (result.success) {
      setSubmitted(true);
      return;
    }
    toast.error(result.error);
  }

  return (
    <div className="cp-landing-request">
      {submitted ? (
        <p className="cp-landing-request__success">
          Thank you. Your request is under review. We will email you when your organization is
          approved.
        </p>
      ) : (
        <Form
          layout="vertical"
          onFinish={onFinish}
          className="cp-landing-request__form"
          requiredMark={false}
        >
          <Form.Item name="companyName" label="Company name" rules={[{ required: true }]}>
            <Input size="large" placeholder="Your company" />
          </Form.Item>
          <div className="cp-landing-request__row">
            <Form.Item
              name="primaryContactFirstName"
              label="First name"
              rules={[{ required: true }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              name="primaryContactLastName"
              label="Last name"
              rules={[{ required: true }]}
            >
              <Input size="large" />
            </Form.Item>
          </div>
          <Form.Item
            name="primaryContactEmail"
            label="Work email"
            rules={[{ required: true, type: 'email' }]}
          >
            <Input size="large" placeholder="you@company.com" />
          </Form.Item>
          <Form.Item name="phone" label="Phone (optional)">
            <Input size="large" />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            block
            className="cp-landing-btn-primary"
          >
            Submit request
          </Button>
        </Form>
      )}
    </div>
  );
};

export default SignupRequestSection;
